import { defaultDateConfig } from './defaultDateConfig';
import { formatDateCustom } from './formatDateCustom';
/**
 * Formats date and time using default config.
 * @param {Date} date - Date to format.
 * @param {string} timeZone - Optional time zone, if not set default from `defaultDateConfig.timeZone` is used.
 * @returns {string} The formatted date string.
 */
export function formatDateTime(date, timeZone) {
    return formatDateCustom(date, defaultDateConfig.dateTimeFormat, timeZone);
}
